import { useAppSelector } from '../../../configuration/setup/hooks';
import { getServiceOrderCategory } from '../reducers/serviceOrdersSlice';
import { ServiceOptions } from './serviceOptions/ServiceOptions';
import { ServiceOrders } from './serviceOrders/ServiceOrders';
import { ServiceCategory } from './shared/commonServiceOrder.types';

export const ServiceOrdersOrOptions = () => {
    const tableCategory = useAppSelector(getServiceOrderCategory);
    const isOptionsTab = tableCategory === ServiceCategory.OPTIONS;

    return isOptionsTab ? <ServiceOptions /> : <ServiceOrders />;
};
